import {AfterViewInit, Component, Injector, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AdminService} from "../dashboard/services/admin.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'admin-user-management-detail',
    templateUrl: './user-management-detail.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class UserManagementDetailComponent extends BasePageComponentDirective<any> implements OnInit, AfterViewInit {
    formAccount: FormGroup;
    user: any = null;
    subscription: any;
    tabActive = 'info';
    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private adminSvc: AdminService
    ) {
        super(injector);
        this.formAccount = this.formBuilder.group({
            fullName: [null, [Validators.required, Validators.minLength(5)]],
            email: [null, [Validators.required, Validators.minLength(5)]],
            phoneNumber: [null, [Validators.required, Validators.minLength(5)]],
            joinDate: [],
            accountType: [],
            expirationDate: []
        })
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        const id = this.activatedRoute.snapshot.params.id;

        if (id) {
            await this.getUser(id);
        } else {
            this.backToUser();
        }
    }

    ngAfterViewInit() {
        const tab = this.activatedRoute.snapshot.queryParams.tab;
        if(tab) {
            switch (tab) {
                case 'info': {
                    this.tabActive = 'info';
                    break;
                }
                case 'ceus': {
                    this.tabActive = 'ceus';
                    break;
                }
                case 'certification': {
                    this.tabActive = 'certification';
                    break;
                }
                case 'scorecard': {
                    this.tabActive = 'scorecard';
                    break;
                }
                default: {
                    this.tabActive = 'info';
                    break;
                }
            }
        }
    }

    async getUser(id: number) {
        this.subscription = await this.adminSvc.getAdminCheckActiveSubscription(id);
        this.formAccount.controls.expirationDate.setValue(this.subscription.expirationDate);
        this.adminSvc.getUserById(id).then(r => {
            this.user = r;
            this.formAccount.controls.fullName.setValue(r.fullName);
            this.formAccount.controls.email.setValue(r.email);
            this.formAccount.controls.phoneNumber.setValue(r.mobileNo);
            this.formAccount.controls.joinDate.setValue(r.createDate);
            this.formAccount.controls.accountType.setValue(r.accountType);

            this.formAccount.controls.joinDate.disable();
            this.formAccount.controls.accountType.disable();
            this.formAccount.controls.expirationDate.disable();
            this.formAccount.controls.email.disable();

        }, _ => {
            this.backToUser();
            return;
        });
    }

    query(): void {
    }

    backToUser() {
        this.router.navigate(['/admin'], {queryParams: {tab: 'user'}}).then();
    }

    saveAccount() {
        if (this.formAccount.invalid) {
            return;
        }
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Update User Account",
                subMessage: "Are you sure want to update user account information?",
                buttonOkLabel: 'Yes, Update',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {
                this.adminSvc.updateAccount(
                    this.formAccount.controls.fullName.value,
                    this.formAccount.controls.phoneNumber.value,
                    this.user.id
                ).then(_ => {
                    this.showAlertDark('User Account', 'Account has been updated successfully', '');
                    this.getUser(this.user.id);
                });
            }
        })
    }

    validatePhone(): void {
        const control = this.formAccount.get('phoneNumber');
        let input = control?.value || '';
        input = input.replace(/\D/g, '').substring(0, 10);
        let size = input.length;
        if (size > 0) {
            input = '(' + input;
        }
        if (size > 3) {
            input = input.slice(0, 4) + ')' + input.slice(4);
        }
        if (size > 6) {
            input = input.slice(0, 8) + '-' + input.slice(8);
        }

        control?.setValue(input);
    }

    refreshWalletCeu($event: any) {
        if($event) {

        }
    }

}
